interface MiniSparklineProps {
  data: number[];
  color?: string;
  height?: number;
}

export default function MiniSparkline({ data, color = '#3B82F6', height = 32 }: MiniSparklineProps) {
  if (!data || data.length < 2) return null;
  
  const max = Math.max(...data);
  const min = Math.min(...data);
  const range = max - min || 1;
  
  // Create SVG path
  const points = data.map((value, index) => {
    const x = (index / (data.length - 1)) * 100;
    const y = height - ((value - min) / range) * height;
    return `${x},${y}`;
  });
  
  const pathData = `M ${points.join(' L ')}`;
  
  return (
    <svg 
      width="100%" 
      height={height} 
      viewBox={`0 0 100 ${height}`} 
      preserveAspectRatio="none"
      className="opacity-60"
    >
      <path
        d={pathData}
        fill="none"
        stroke={color}
        strokeWidth="2"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}

